import { useEffect, useRef, useState } from 'react';
import '../css/fadeInSection.css'

export function FadeInSection(props) {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  /*
  useEffect(() => {
      const timeoutId = setTimeout(() => {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => setIsVisible(entry.isIntersecting));
        });

        if (domRef.current) {
          observer.observe(domRef.current);
        }

        return () => {
          if (domRef.current) {
            observer.unobserve(domRef.current);
          }
        };
      }, 1000);
      
      return () => clearTimeout(timeoutId);
  }, []);
  */

  useEffect(() => {  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => setIsVisible(entry.isIntersecting));
    });

    if (domRef.current) {
      observer.observe(domRef.current);
    }
  }, []);
  
  return (
    <div
      className={`fade-in-section${props.fade ? "-fade" : (props.late ? "-late" : "")} ${isVisible ? "is-visible" : ""}`}
      ref={domRef}
    >
      {props.children}
    </div>
  );
}